export var IResellerCertificate;
(function (IResellerCertificate) {
    let ValidationSchema;
    (function (ValidationSchema) {
        ValidationSchema["RESELLER_ID"] = "RESELLER_ID";
        ValidationSchema["GOOGLE_PLACE_ID"] = "GOOGLE_PLACE_ID";
        ValidationSchema["NOT_APPLICABLE"] = "NOT_APPLICABLE";
        ValidationSchema["SCHEMA_STATE_GROUP_0"] = "SCHEMA_STATE_GROUP_0";
        /**
         * @deprecated
         */
        ValidationSchema["SCHEMA_STATE_GROUP_1A"] = "SCHEMA_STATE_GROUP_1A";
        /**
         * @deprecated
         */
        ValidationSchema["SCHEMA_STATE_GROUP_1B"] = "SCHEMA_STATE_GROUP_1B";
        ValidationSchema["SCHEMA_STATE_GROUP_2A"] = "SCHEMA_STATE_GROUP_2A";
        ValidationSchema["SCHEMA_STATE_GROUP_2B"] = "SCHEMA_STATE_GROUP_2B";
        ValidationSchema["SCHEMA_STATE_GROUP_3A"] = "SCHEMA_STATE_GROUP_3A";
        ValidationSchema["SCHEMA_STATE_GROUP_3B"] = "SCHEMA_STATE_GROUP_3B";
        ValidationSchema["SCHEMA_STATE_GROUP_4"] = "SCHEMA_STATE_GROUP_4";
        ValidationSchema["SCHEMA_STATE_GROUP_5"] = "SCHEMA_STATE_GROUP_5";
        ValidationSchema["SCHEMA_STATE_GROUP_6"] = "SCHEMA_STATE_GROUP_6";
        ValidationSchema["SCHEMA_STATE_GROUP_7"] = "SCHEMA_STATE_GROUP_7";
        ValidationSchema["SCHEMA_STATE_GROUP_8"] = "SCHEMA_STATE_GROUP_8";
        ValidationSchema["SCHEMA_STATE_GROUP_1"] = "SCHEMA_STATE_GROUP_1";
        ValidationSchema["SCHEMA_STATE_GROUP_9"] = "SCHEMA_STATE_GROUP_9";
        ValidationSchema["SCHEMA_STATE_GROUP_10"] = "SCHEMA_STATE_GROUP_10";
        ValidationSchema["SCHEMA_STATE_GROUP_11"] = "SCHEMA_STATE_GROUP_11";
        ValidationSchema["DECLARED_NOT_ELIGIBLE"] = "DECLARED_NOT_ELIGIBLE";
    })(ValidationSchema = IResellerCertificate.ValidationSchema || (IResellerCertificate.ValidationSchema = {}));
    /**
     * Return an instance of IResellerCertificate with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IResellerCertificate.build = (partial) => (Object.assign({ documents: [] }, (partial !== null && partial !== void 0 ? partial : {})));
})(IResellerCertificate || (IResellerCertificate = {}));
